// @flow

import ApiObject from './ApiObject';
import ViewUtils from '../utils/ViewUtils';

import ApiConstants from '../constants/ApiConstants';

export default class RestaurantColors extends ApiObject {

  backgroundColor: number = ApiConstants.RestaurantTheme.DEFAULT_BACKGROUND_COLOR;

  fontColor: number = ApiConstants.RestaurantTheme.DEFAULT_FONT_COLOR;

  titleBackgroundColor: number = ApiConstants.RestaurantTheme.DEFAULT_TITLE_BACKGROUND_COLOR;

  titleFontColor: number = ApiConstants.RestaurantTheme.DEFAULT_TITLE_FONT_COLOR;

  actionBackgroundColor: number = ApiConstants.RestaurantTheme.DEFAULT_ACTION_BACKGROUND_COLOR;

  actionFontColor: number = ApiConstants.RestaurantTheme.DEFAULT_ACTION_FONT_COLOR;

  // -- RGB format

  /**
   * Return a rgba(r,g,b,a) string for css.
   * @returns {String}
   */
  getBackgroundColorFormat(): string {
    return ViewUtils.uintColorToRgbaFormat(this.backgroundColor);
  }

  /**
   * Return a rgba(r,g,b,a) string for css.
   * @returns {String}
   */
  getFontColorFormat(): string {
    return ViewUtils.uintColorToRgbaFormat(this.fontColor);
  }

  getTitleBackgroundColorFormat() {
    return ViewUtils.uintColorToRgbaFormat(this.titleBackgroundColor);
  }

  getTitleFontColorFormat() {
    return ViewUtils.uintColorToRgbaFormat(this.titleFontColor);
  }

  getActionBackgroundColorFormat() {
    return ViewUtils.uintColorToRgbaFormat(this.actionBackgroundColor);
  }

  getActionFontColorFormat() {
    return ViewUtils.uintColorToRgbaFormat(this.actionFontColor);
  }

  // -- get hexa

  getBackgroundColorAsHexadecimal(): string {
    return ViewUtils.uintColorToHexadecimal(this.backgroundColor);
  }

  getFontColorAsHexadecimal(): string {
    return ViewUtils.uintColorToHexadecimal(this.fontColor);
  }

  getTitleBackgroundColor(): string {
    return ViewUtils.uintColorToHexadecimal(this.titleBackgroundColor);
  }

  getTitleFontColor(): string {
    return ViewUtils.uintColorToHexadecimal(this.titleFontColor);
  }

  getActionBackgroundColor(): string {
    return ViewUtils.uintColorToHexadecimal(this.actionBackgroundColor);
  }

  getActionFontColor(): string {
    return ViewUtils.uintColorToHexadecimal(this.actionFontColor);
  }

  // -- set hexa

  setBackgroundColorAsHexadecimal(color: string) {
    this.backgroundColor = ViewUtils.hexadecimalColorToUint(color);
  }

  setFontColorAsHexadecimal(color: string) {
    this.fontColor = ViewUtils.hexadecimalColorToUint(color);
  }

  setTitleBackgroundColor(color: string) {
    this.titleBackgroundColor = ViewUtils.hexadecimalColorToUint(color);
  }

  setTitleFontColor(color: string) {
    this.titleFontColor = ViewUtils.hexadecimalColorToUint(color);
  }

  setActionBackgroundColor(color: string) {
    this.actionBackgroundColor = ViewUtils.hexadecimalColorToUint(color);
  }

  setActionFontColor(color: string) {
    this.actionFontColor = ViewUtils.hexadecimalColorToUint(color);
  }

}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/RestaurantColors.js